import styled from 'styled-components';

import { NumberInput } from '@dreryk/react-components';

export const StyledQuantityNumberInput = styled(NumberInput)`
   width: 70px;
`;

StyledQuantityNumberInput.displayName = 'StyledQuantityNumberInput';
